// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"W9-z","subtitle":"X9-z","wrapper":"Y9-z","leftArrow":"Z9-z","rightArrow":"_9-z"};